import React from 'react';
import queryString from 'query-string';
import Icon from 'assets/icons';
import styles from './FolderBack.module.scss';
import FolderIcon from 'assets/icons/file_type_icons/folder.svg';
import { Link, useParams } from 'react-router-dom';
import { GetName, getFolderBackLink } from 'screens/FolderScreen/utils';

export const FolderBack = () => {
  const { folderId } = useParams();
  const params = queryString.parse(window.location.search, { arrayFormat: 'comma' });

  return (
    <div className={styles.container}>
      <Link to={getFolderBackLink(params, folderId)} className={styles.linkWrap}>
        <Icon.ChevronThick className={styles.chevron} />
      </Link>
      <img className={styles.folder} src={FolderIcon} alt="" />
      <span className={styles.folderName}>
        <GetName nodeId={folderId} />
      </span>
    </div>
  );
};
